/* HOOKSTER - home review carousel. Two jobs:
     1. size the track to the TALLEST card
     2. auto-advance it, so the strip reads as several reviews and not one

   1. HEIGHT
   Impulse runs the strip on Flickity with adaptiveHeight: true, so the
   viewport tracks the SELECTED cell. Fine for a one-up slider, but this shows
   three cards at once on desktop and a peeking neighbour on mobile, so a
   taller card beside a shorter selected one is clipped by overflow: hidden.

   The CSS used to solve that by forcing every card to height: 100% against a
   hard-coded floor (260 desktop / 290 mobile). Two problems:

   a. Short reviews got a card far taller than their text - at 496px the floor
      was 290 and Paul's review needs 174, so 116px of empty card under the
      author. That is the bit Adam reported.

   b. The floor was wrong the other way at tablet widths. Measured tallest:
        320:316  375:276  496:235  769:377  1024:276  1440:215
      769 is worst - the 3-up row starts there and cards are narrowest. The
      260px floor was 117px short, so the longest review clipped on tablets.
      No single pair of numbers covers a 215-377 range.

   So the CSS lets each card hug its content and this sets the viewport's
   min-height to the tallest card at the current width. Floors left in the CSS
   are a no-JS fallback - do not tune them as if they were the layout.

   2. AUTOPLAY
   On a phone only one card is in view, so the strip looked like the store has
   a single review. Flickity is already initialised with wrapAround: true, so
   this only has to switch autoPlay on and start the player. It pauses on
   hover, on keyboard focus, and whenever the strip is off screen, and it is
   skipped entirely under prefers-reduced-motion.

   Flickity initialises lazily on scroll, so neither job can run at
   DOMContentLoaded - hence the observer, which gives up after 20s. */

(function () {
  'use strict';

  var SECTION = '[id*="social-proof"]';
  var SLIDER = '.testimonials-slider';
  var CELL = '.testimonials-slide';
  var AUTOPLAY_MS = 5000;

  var autoplayDone = false;

  function fit(section) {
    var vp = section.querySelector('.flickity-viewport');
    var cells = section.querySelectorAll(CELL);
    if (!vp || !cells.length) return;

    var tallest = 0;
    for (var i = 0; i < cells.length; i++) {
      var h = cells[i].getBoundingClientRect().height;
      if (h > tallest) tallest = h;
    }
    /* Cards no longer depend on the viewport's height, so measuring while a
       min-height is set is not circular and needs no reset-and-reflow. */
    if (tallest > 0) vp.style.minHeight = Math.ceil(tallest) + 'px';
  }

  function autoplay(section) {
    if (autoplayDone) return;

    var el = section.querySelector(SLIDER);
    if (!el || !window.Flickity || !window.Flickity.data) return;

    var flkty = window.Flickity.data(el);
    if (!flkty || !flkty.player || flkty.slides.length < 2) return;

    autoplayDone = true;

    if (window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    /* Flickity's Player reads the interval off options at tick time, so
       setting it after init and calling play() is enough. */
    flkty.options.autoPlay = AUTOPLAY_MS;
    flkty.player.play();

    /* pauseAutoPlayOnHover only binds at init, so wire it up by hand. */
    el.addEventListener('mouseenter', function () { flkty.player.pause(); });
    el.addEventListener('mouseleave', function () { flkty.player.unpause(); });
    el.addEventListener('focusin', function () { flkty.player.pause(); });

    /* Do not cycle through the reviews while nobody is looking at them. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) flkty.player.play();
          else flkty.player.stop();
        }
      }, { threshold: 0.25 }).observe(el);
    }
  }

  function run() {
    var sections = document.querySelectorAll(SECTION);
    for (var i = 0; i < sections.length; i++) {
      fit(sections[i]);
      autoplay(sections[i]);
    }
  }

  var timer;
  function onResize() {
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  }

  function start() {
    if (!document.querySelector(SECTION)) return;

    run();
    window.addEventListener('resize', onResize);

    /* Webfonts change the wrap, so re-measure once they land. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run).catch(function () {});
    }

    if (!window.MutationObserver) return;
    var mo = new MutationObserver(run);
    var sections = document.querySelectorAll(SECTION);
    for (var i = 0; i < sections.length; i++) {
      mo.observe(sections[i], { childList: true, subtree: true });
    }
    /* Setting a style attribute is not a childList change, so this cannot
       re-trigger itself. Disconnect anyway once the page has settled. */
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
